import { render, staticRenderFns } from "./PageOrdinaryPackage.vue?vue&type=template&id=6fb07227"
import script from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"
export * from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb07227')) {
      api.createRecord('6fb07227', component.options)
    } else {
      api.reload('6fb07227', component.options)
    }
    module.hot.accept("./PageOrdinaryPackage.vue?vue&type=template&id=6fb07227", function () {
      api.rerender('6fb07227', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/componentsCSG/PageOrdinaryPackage.vue"
export default component.exports